import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const API_URL = 'https://cru-forms.cruio.workers.dev/api/modern-commerce';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    website: '',
    projectType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          company: formData.company,
          phone: formData.phone,
          website: formData.website,
          projecttype: formData.projectType,
          message: formData.message
        })
      });
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          website: '',
          projectType: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-210">
      <Header data-id="element-211" />
      <section className="pt-32 pb-20 px-10" data-id="element-212">
        <div className="max-w-[1400px] mx-auto" data-id="element-213">
          <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-214">
            Get in <span className="text-[#D4A574]" data-id="element-215">Touch</span>
          </h1>
          <p className="text-[#8B7355] text-xl max-w-2xl mb-10 leading-relaxed font-['Inter']" data-id="element-216">
            Got a project in mind? Let's talk - new builds, migrations, email,
            ongoing support. We'd love to hear from you.
          </p>

          <div className="bg-white p-12 rounded-xl shadow-md max-w-3xl" data-id="element-217">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-218">
              {/* Name */}
              <div data-id="element-219">
                <label htmlFor="name" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-220">
                  Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-221" />
              </div>

              {/* Email */}
              <div data-id="element-222">
                <label htmlFor="email" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-223">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-224" />
              </div>

              {/* Phone */}
              <div data-id="element-225">
                <label htmlFor="phone" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-226">
                  Phone
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-227" />
              </div>

              {/* Company Name */}
              <div data-id="element-228">
                <label htmlFor="company" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-229">
                  Company Name
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-230" />
              </div>

              {/* Website URL */}
              <div data-id="element-231">
                <label htmlFor="website" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-232">
                  Website URL
                </label>
                <input type="text" id="website" name="website" value={formData.website} onChange={handleChange} placeholder="www.example.com" disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-233" />
              </div>

              {/* Project Type */}
              <div data-id="element-234">
                <label htmlFor="projectType" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-235">
                  Project Type
                </label>
                <select id="projectType" name="projectType" value={formData.projectType} onChange={handleChange} required disabled={isSubmitting} className="w-full pl-4 pr-12 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] bg-white appearance-none disabled:opacity-50 disabled:cursor-not-allowed" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%232C2416' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 1rem center',
                backgroundSize: '12px 8px'
              }} data-id="element-236">
                  <option value="" data-id="element-237">Select a project type</option>
                  <option value="new-build" data-id="element-238">New Build</option>
                  <option value="migration" data-id="element-239">Migration</option>
                  <option value="shopify-pos" data-id="element-240">Shopify POS</option>
                  <option value="email" data-id="element-241">Email</option>
                  <option value="support" data-id="element-242">Support</option>
                  <option value="other" data-id="element-243">Other</option>
                </select>
              </div>

              {/* Message */}
              <div data-id="element-244">
                <label htmlFor="message" className="block text-[#2C2416] font-medium mb-2 font-['Inter']" data-id="element-245">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} disabled={isSubmitting} className="w-full px-4 py-3 border border-[#D4A57440] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent transition-all font-['Inter'] resize-vertical disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-246" />
              </div>

              {/* Success/Error Messages */}
              {submitStatus === 'success' && <div className="bg-[#D4A574] bg-opacity-10 border border-[#D4A574] text-[#2C2416] px-6 py-4 rounded-lg font-['Inter']" data-id="element-247">
                  Thanks for reaching out. We will be in touch soon.
                </div>}

              {submitStatus === 'error' && <div className="bg-red-50 border border-red-300 text-red-800 px-6 py-4 rounded-lg font-['Inter']" data-id="element-248">
                  Something went wrong. Please try again or email directly.
                </div>}

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="bg-[#2C2416] text-[#FAF7F2] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#D4A574] font-['Inter'] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100" data-id="element-249">
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer data-id="element-250" />
    </div>;
}